import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appMouseWheel]'
})
export class MouseWheelDirective {

  constructor() { }
  @HostListener('wheel', ['$event']) blockPaste(e: any) {
    e.preventDefault();
  }

}
